module.exports = __webpack_public_path__ + "img/visa.6cf661a2.png";